export default "__VITE_ASSET__CxS_feRI__"